import { useMutation } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import queryClient from '../../config/react-query'
import QueryKeys from './QueryKeys'
import { Patient } from './usePatient'

interface PatientInviteOnlyResponse {
  patient: Patient
}

interface PatientInviteOnlyBody {
  firstName: string
  lastName: string
  cellPhoneLocal: string
  dateOfBirth: string | Date
}

const useInvitePatient = () => {
  const siteId = useCurrentSite()?.id
  const url = '/impacts/patients/invite_only'

  return useMutation((vars: PatientInviteOnlyBody) =>
    request
      .post<PatientInviteOnlyResponse>(url, {
        siteIds: [siteId],
        patientInvite: {
          siteId: siteId,
          ...vars,
          providerId: undefined,
        },
      })
      .then((r) => {
        queryClient.invalidateQueries(QueryKeys.upcomingDashboard(siteId))
        return r.data
      }),
  )
}

export default useInvitePatient
